<template>
  <div class="col-12">
    <div class="col-sm-12 search-form-title mx-2">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <div class="row px-2">
        <div class="col-sm-6">
          <span class="span-title">{{ $t('street_lights.status') }}</span>
          <select
            v-model="status"
            class="form-select form-select-sm"
          >
            <option :value="null">
              {{ $t('common.all') }}
            </option>
            <option v-for="option in statusOptions" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="col-sm-6">
          <span class="span-title">{{ $t('street_lights.station') }}</span>
          <select
            id="lightStation"
            v-model="station"
            class="form-select form-select-sm"
          >
            <option :value="null">
              {{ $t('street_lights.select_station') }}
            </option>
            <option v-for="item in stations" :key="item.value" :value="item.value">
              {{ item.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12">
        <contract-filter
          ref="filter"
          :user="user"
          class="px-2"
          :show-only-my-contracts-option="true"
          @contract-set="setContract"
          @company-set="companySet"
        />
      </div>
      <div class="col-sm-12 button-container">
        <button
          type="reset"
          class="btn btn-danger form-button"
        >
          {{ $t('ins_report.clear') }}
        </button>
          <button
              type="submit"
              class="btn btn-primary form-button"
          >
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </form>
  </div>
</template>

<script>
import ContractFilter from '../contract/ContractFilter'
import {timeUtils} from '../mixins/TimeUtils'
import {restApi} from "@/components/mixins/RestApiMixin"
import {cableHelper} from "@/components/mixins/CableMixin";
import {streetLightHelper} from "@/components/mixins/StreetLightMixin";

export default {
    name: 'CableSearch',
    components: {ContractFilter},
    mixins: [timeUtils, restApi, cableHelper, streetLightHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            OK: 1,
            DEFECT: 2,
            PLANNED: 3,
            NOT_IN_USE: 4,
            contract: null,
            company: null,
            status: null,
            stations: [],
            station: null
        }
    },
    mounted() {
        this.fetchStations()
    },
    methods: {
        setContract: function (contract) {
            this.contract = contract
        },
        companySet: function (company) {
            this.company = company
        },
        onSubmit: function () {
            let params = {}
            if (this.contract) {
                params.contract = this.contract
            }
            if (this.sign) {
                params.sign = this.sign.value
            }
            if (this.company) {
                params.company = this.company
            }
            if (this.status) {
                params.status = this.status
            }
            if (this.station) {
                params.station = this.station
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.contract = null
            this.status = null
            this.station = null
            this.$refs.filter.resetData()
        },
        fetchStations() {
            this.loading = true
            this.stations = []
            this.restFetch(this.powerStationUrl, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            if (response && response.data) {
                response.data.forEach(station => {
                    this.stations.push({value: station.id, text: station.id + ' ' + station.location_name})
                })
            }
            this.loading = false
        },
    }
}
</script>
